import React, { Component } from 'react';

class Portfolio extends Component {
  render() {

    if(this.props.data){
      var projects = this.props.data.gallery.map(function(projects){
        var projectImage = 'images/gallery/'+projects.image;
        return <div key={projects.title} className="columns portfolio-item">
           <div className="item-wrap">
            <a href={projects.url} title={projects.title}>
               <img className="image" alt={projects.title} src={projectImage} />
               <h5>{projects.title}</h5>
              <div className="link-icon"><i className="fa fa-link"></i></div>
            </a>
          </div>
        </div>
      })
    }

    return (
      <section id="gallery">

      <div className="row">

         <div className="columns collapsed">
         <div className="box">
            <h1>Gallery</h1>

            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                {projects}
            </div>
          </div>
          </div>
      </div>
   </section>
    );
  }
}

export default Portfolio;
